import React, { useState, useRef, useEffect } from 'react';
import { Link } from "react-router-dom";
import Select from "react-select";
import { Button } from "react-bootstrap";
import "react-datepicker/dist/react-datepicker.css";
import 'datatables.net';
import 'datatables.net-dt/css/dataTables.dataTables.css';
import "react-datepicker/dist/react-datepicker.css";
import vehicle from '../../../../images/vehicle/default_machinery.png';
import swal from "sweetalert2";
import DatePicker, { DateObject } from "react-multi-date-picker";
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import { addDays } from 'date-fns';

const EditVehicle = () => {
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const machinery_id = queryParams.get('data');

    const branch_id = parseInt(localStorage.getItem("branch_id"), 10);
    const navigate = useNavigate();
    const baseURL = process.env.REACT_APP_API_BASE_URL;
    const imgBaseUrl = process.env.REACT_APP_IMG_BASE_URL;

    const [catego, setcatego] = useState(null);
    const [Selcatego, setSelcatego] = useState(null);
    const [name, setName] = useState('');
    const [brand, setbrand] = useState('');
    const [serial_no, setSerialNo] = useState('');
    const [insArea, setinsArea] = useState('');
    const [manufactured_date, setmanufacDate] = useState('');
    const [manufactured_datedisp, setmanufacDatedisp] = useState(null);
    const [registration_date, setregistrationdate] = useState('');
    const [registration_dateDisp, setregistrationdateDisp] = useState(null);
    const [purpose, setporpose] = useState(null);
    const [selpurpose, setselporpose] = useState(null);
    const [maintanencedate, setmaintanencedate] = useState('');
    const [maintanencedateDisp, setmaintanencedateDisp] = useState(null);
    const [description, setdescription] = useState('');
    const [image, setimage] = useState(null);
    const [imageurl, setimageurl] = useState(null);
    const imageInputRef = useRef(null);
    const [deleteimage, setdeleteimage] = useState(0);

    const [insurance, setinsurance] = useState(null);
    const [insurance_company, setinsurancecompany] = useState('');
    const [insurance_start_date, setinsurance_start_date] = useState('');
    const [insurance_start_dateDisp, setinsurance_start_dateDisp] = useState(null);
    const [isChecked, setIsChecked] = useState(false);
    const [insurance_end_date, setinsurance_end_date] = useState('');
    const [insurance_end_dateDisp, setinsurance_end_dateDisp] = useState(null);
    const [insurance_prolicy, setinsurance_policy] = useState('');

    const [hasFetched, setHasFetched] = useState(false);
    const [errors, setErrors] = useState({});

    const [categoryoption, setCategoryOption] = useState([]);
    useEffect(() => {
        const fetchLeadSource = async () => {
            try {
                const response = await axios.get(`${baseURL}/machinery_category/get_active`);
                const formattedsource = response.data.map(item => ({
                    value: item.sno,
                    label: item.category_name,
                }));
                setCategoryOption(formattedsource);
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };

        fetchLeadSource();
    }, []);

    const vehicle_purpose = [
        { value: "1", label: "Production" },
        { value: "2", label: "Utility" },
        { value: "3", label: "Packaging" },
        { value: "4", label: "Others" }
    ];

    // date convertion
    function formatDateToDDMMYYYY(dateString) {
        if (dateString) {
            const [year, month, day] = dateString.split("-");
            return `${day}-${month}-${year}`;
        }
        return '';
    }

    useEffect(() => {
        if (machinery_id && categoryoption.length) {
            axios.get(`${baseURL}/manage_machinery/${machinery_id}`)
                .then(response => {
                    const data = response.data.data;

                    const catego = categoryoption.find(itm => itm.value == data.category_id);
                    setcatego(catego.value);
                    setSelcatego(catego);

                    setName(data.machinery_name);
                    setbrand(data.brand_name);
                    setSerialNo(data.serial_number);
                    if (data.manufacture_date) {
                        setmanufacDate(data.manufacture_date);
                        setmanufacDatedisp(formatDateToDDMMYYYY(data.manufacture_date));
                    }
                    setregistrationdate(data.purchase_date);
                    setregistrationdateDisp(formatDateToDDMMYYYY(data.purchase_date));
                    const purpose = vehicle_purpose.find(itm => itm.value == data.machinery_purpose);
                    setporpose(purpose.value);
                    setselporpose(purpose);
                    setinsArea(data.instalation_area);
                    setmaintanencedate(data.upcoming_maintenance);
                    setmaintanencedateDisp(formatDateToDDMMYYYY(data.upcoming_maintenance));
                    setdescription(data.description);

                    setinsurance(data.insurance_information);
                    if (data.insurance_information === 1) {
                        setIsChecked(true);
                        setinsurancecompany(data.insurance_company);
                        setinsurance_policy(data.insurance_policy_number);
                        if (data.insurance_start_date) {
                            setinsurance_start_date(data.insurance_start_date);
                            setinsurance_start_dateDisp(formatDateToDDMMYYYY(data.insurance_start_date));
                        }
                        if (data.insurance_end_date) {
                            setinsurance_end_date(data.insurance_end_date);
                            setinsurance_end_dateDisp(formatDateToDDMMYYYY(data.insurance_end_date));
                        }
                    }
                    setimageurl(data.machinery_image);
                    setHasFetched(true);
                })
                .catch(error => {
                    console.log('There was an error fetching the data!', error);
                    setHasFetched(true);
                });
        }
    }, [machinery_id, categoryoption]);


    // Handle checkbox change
    const handleCheckboxChange = () => {
        setIsChecked(!isChecked);
    };

    useEffect(() => {
        if (isChecked) {
            setinsurance(1);
        } else {
            setinsurance(0);
        }
    }, [isChecked]);

    const fileHandler = (e) => {
        const file = e.target.files[0];

        if (file) {
            const allowedTypes = ['image/jpeg', 'image/png', 'image/jpg'];
            const maxSizeKB = 50; // max size in KB

            if (!allowedTypes.includes(file.type)) {
                swal.fire('Error', 'Only JPG, JPEG, and PNG files are allowed.', 'error');
                e.target.value = null; // reset file input
                return;
            }

            if (file.size / 1024 > maxSizeKB) {
                swal.fire('Error', 'File size must be less than 50 KB.', 'error');
                e.target.value = null; // reset file input
                return;
            }
            setimage(file);
            setdeleteimage(0);
        }
    };

    function RemoveImage() {
        setimage(null);
        setimageurl(null);
        setdeleteimage(1);
    }

    const ConfirmationModal = () => {
        swal.fire({
            html: `
                       <div class="alert alert-success px-2 py-2" role="alert">
                           Are You Sure Want to Update Vehicle
                           <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
                       </div>
                       <p class="text-center"><b>${name}</b></p>
                       <div class="text-center">
                           <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" width="48" height="48">
                           <defs>
                            <style>.cls-2{fill:#273941}.cls-5{fill:#f6fafd}
                            </style>
                            </defs>
                            <g id="_03-smile" data-name="03-smile"><circle cx="24" cy="24" r="23" style="fill:#ffce52"/>
                            <path class="cls-2" d="M24 39c-7.168 0-13-4.935-13-11h2c0 4.962 4.935 9 11 9s11-4.038 11-9h2c0 6.065-5.832 11-13 11zM20 21h-2c0-2.206-1.346-4-3-4s-3 1.794-3 4h-2c0-3.309 2.243-6 5-6s5 2.691 5 6zM38 21h-2c0-2.206-1.346-4-3-4s-3 1.794-3 4h-2c0-3.309 2.243-6 5-6s5 2.691 5 6z"/>
                            <path d="M24 4c12.15 0 22 8.507 22 19h.975a23 23 0 0 0-45.95 0H2C2 12.507 11.85 4 24 4z" style="fill:#ffe369"/>
                            <path d="M46 23c0 10.493-9.85 19-22 19S2 33.493 2 23h-.975c-.014.332-.025.665-.025 1a23 23 0 0 0 46 0c0-.335-.011-.668-.025-1z" style="fill:#ffb32b"/>
                            <ellipse class="cls-5" cx="37" cy="9" rx=".825" ry="1.148" transform="rotate(-45.02 37 9)"/>
                            <ellipse class="cls-5" cx="30.746" cy="4.5" rx=".413" ry=".574" transform="rotate(-45.02 30.745 4.5)"/>
                            <ellipse class="cls-5" cx="34" cy="7" rx="1.65" ry="2.297" transform="rotate(-45.02 34 7)"/></g>
                            </svg>
                       </div>
                   `,
            showCancelButton: true,
            confirmButtonText: 'Yes!',
            cancelButtonText: 'No',
            reverseButtons: true,
            customClass: {
                title: 'fs-6',
                cancelButton: 'btn btn-sm btn-secondary',
                confirmButton: 'btn btn-sm btn-success',
                htmlContainer: 'text-left'
            },
            allowOutsideClick: false,
            allowEscapeKey: false,
        }).then((result) => {
            if (result.isConfirmed) {

                const formData = new FormData();

                // Append regular fields
                formData.append('branch_id', branch_id);
                formData.append('category_id', catego);
                formData.append('machinery_name', name);
                formData.append('brand_name', brand);
                formData.append('serial_number', serial_no);
                formData.append('manufacture_date', manufactured_date);
                formData.append('purchase_date', registration_date);
                formData.append('instalation_area', insArea);
                formData.append('machinery_purpose', purpose);
                formData.append('upcoming_maintenance', maintanencedate);
                formData.append('insurance_information', insurance);
                formData.append('description', description);

                formData.append('insurance_company', insurance_company);
                formData.append('insurance_policy_number', insurance_prolicy);
                formData.append('insurance_start_date', insurance_start_date);
                formData.append('insurance_end_date', insurance_end_date);
                formData.append('delete_image', deleteimage);

                if (image) {
                    formData.append('machinery_image', image);
                }

                for (let pair of formData.entries()) {
                    console.log(pair[0] + ':', pair[1]);
                }

                axios.post(`${baseURL}/manage_machinery/${machinery_id}`, formData)
                    .then(response => {
                        navigate('/manage-machinery', {
                            state: { toastMessage: 'Machinery Updated Successfully!', toastType: 'success' }
                        });
                    }).catch(error => {
                        console.log(error);
                        navigate('/manage-machinery', {
                            state: { toastMessage: 'Machinery updation Failed', toastType: 'error' }
                        });
                    });
            }
        });
    };

    const validate = () => {
        const newErrors = {};
        if (!brand) {
            newErrors.brand = "This Field is Required.";
        }

        if (!catego) {
            newErrors.catego = "This Field is Required.";
        }

        if (!name) {
            newErrors.name = "This Field is Required.";
        }

        if (!serial_no) {
            newErrors.serial_no = "This Field is Required.";
        }

        if (!registration_date) {
            newErrors.redate = "This Field is Required.";
        }

        if (!purpose) {
            newErrors.purpose = "This field is required.";
        }

        if (!maintanencedate) {
            newErrors.mdate = "This Field is Required.";
        }

        if (isChecked) {
            if (!insurance_company) {
                newErrors.comp = "This Field is Required.";
            }
            if (!insurance_start_date) {
                newErrors.sdate = "This Field is Required.";
            }
            if (!insurance_end_date) {
                newErrors.edate = "This Field is Required.";
            }
            if (!insurance_prolicy) {
                newErrors.policy = "This Field is Required.";
            }
        }
        console.log(newErrors);
        return newErrors;
    };

    const handleSubmit = (event) => {
        event.preventDefault();

        const validationErrors = validate();
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        } else {
            setErrors({});
        }

        ConfirmationModal();
    };


    return (
        <>

            <div className="d-flex align-items-center justify-content-between page-titles px-0 py-1 mx-0 flex-wrap">
                <div className='mb-2'>
                    <div className="mb-0 px-0">
                        <h4 className='breadcrumb-header'>Update Machinery</h4>
                    </div>
                    <ol className="breadcrumb fs-7">
                        <li className="breadcrumb-item"><Link to='/dashboard'>Dashboard</Link></li>
                        <li className="breadcrumb-item"><i class="fa-solid fa-angles-right fs-8"></i></li>
                        <li className="breadcrumb-item">Maintenance Management</li>
                        <li className="breadcrumb-item"><i class="fa-solid fa-angles-right fs-8"></i></li>
                        <li className="breadcrumb-item active"><Link to='/manage-vehicles'>Manage Machinery</Link></li>
                    </ol>
                </div>
            </div>

            <label className='text-red fs-4 font-w600 mb-3'>Basic Information</label>
            <div className="row">
                <div className="col-lg-4 mb-4">
                    <label className="text-black font-w500 fs-7">Machinery Category <span className="required">*</span></label>
                    <Select placeholder="Select Machinery Category"
                        onChange={(e) => setcatego(e.value)}
                        value={Selcatego}
                        options={categoryoption}
                    />
                    {errors.catego && <div className="text-danger fs-8 mt-1">{errors.catego}</div>}
                </div>

                <div className="col-lg-4 mb-4">
                    <label className="text-black font-w500 fs-7">Machinery Name<span className="required">*</span></label>
                    <input type="text" className="form-control" placeholder="Enter Machinery Name"
                        maxLength={300}
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                    />
                    {errors.name && <div className="text-danger fs-8 mt-1">{errors.name}</div>}
                </div>

                <div className="col-lg-4 mb-4">
                    <label className="text-black font-w500 fs-7">Machinery Brand<span className="required">*</span></label>
                    <input type="text" className="form-control" placeholder="Enter Machinery Brand"
                        maxLength={300}
                        value={brand}
                        onChange={(e) => setbrand(e.target.value)}
                    />
                    {errors.brand && <div className="text-danger fs-8 mt-1">{errors.brand}</div>}
                </div>

                <div className="col-lg-4 mb-4 ">
                    <label className="text-black font-w500 fs-7">Serial Number<span className="required">*</span></label>
                    <input type="text" className="form-control" placeholder="Enter Serial Number"
                        maxLength={300}
                        value={serial_no}
                        onChange={(e) => setSerialNo(e.target.value)}
                    />
                    {errors.serial_no && <div className="text-danger fs-8 mt-1">{errors.serial_no}</div>}
                </div>

                <div className="col-lg-4 mb-4">
                    <label className="text-black font-w500 fs-7">Manufactured Date</label>
                    <div className='datepicker-wrapper d-flex'>
                        <div className='input-group-text bg-transparent border-0 px-0'><i className='fa-solid fa-calendar-days fs-4'></i></div>
                        <DatePicker placeholder='Select Manufactured Date'
                            value={manufactured_datedisp}
                            onChange={(date) => {
                                setmanufacDatedisp(date);
                                const formattedDate = date.format('YYYY-MM-DD');
                                setmanufacDate(formattedDate);
                            }}
                            format="DD-MM-YYYY"
                        />
                    </div>
                </div>

                <div className="col-lg-4 mb-4">
                    <label className="text-black font-w500 fs-7">Purchase Date<span className="required">*</span></label>
                    <div className='datepicker-wrapper d-flex'>
                        <div className='input-group-text bg-transparent border-0 px-0'><i className='fa-solid fa-calendar-days fs-4'></i></div>
                        <DatePicker placeholder='Select Purchase Date'
                            value={registration_dateDisp}
                            onChange={(date) => {
                                setregistrationdateDisp(date);
                                const formattedDate = date.format('YYYY-MM-DD');
                                setregistrationdate(formattedDate);
                            }}
                            format="DD-MM-YYYY"
                        />
                    </div>
                    {errors.redate && <div className="text-danger fs-8 mt-1">{errors.redate}</div>}
                </div>

                <div className="col-lg-4 mb-4 ">
                    <label className="text-black font-w500 fs-7 ">Installation Area</label>
                    <input type="text" className="form-control" placeholder="Enter Installation Area"
                        maxLength={300}
                        value={insArea}
                        onChange={(e) => setinsArea(e.target.value)}
                    />
                </div>

                <div className="col-lg-4 mb-4 ">
                    <label className="text-black font-w500 fs-7">Machinery Purpose<span className="required">*</span></label>
                    <Select placeholder="Select Vehicle Purpose"
                        onChange={(e) => setporpose(e.value)}
                        value={selpurpose}
                        options={vehicle_purpose}
                    />
                    {errors.purpose && <div className="text-danger fs-8 mt-1">{errors.purpose}</div>}
                </div>

                <div className="col-lg-4 mb-4">
                    <label className="text-black font-w500 fs-7 ">Upcoming Maintenance Date<span className="required">*</span></label>
                    <div className='datepicker-wrapper d-flex'>
                        <div className='input-group-text bg-transparent border-0 px-0'><i className='fa-solid fa-calendar-days fs-4'></i></div>
                        <DatePicker placeholder='Select Upcoming Maintenance Date'
                            value={maintanencedateDisp}
                            minDate={addDays(new Date(), 1)}
                            onChange={(date) => {
                                setmaintanencedateDisp(date);
                                const formattedDate = date.format('YYYY-MM-DD');
                                setmaintanencedate(formattedDate);
                            }}
                            format="DD-MM-YYYY"
                        />
                    </div>
                    {errors.mdate && <div className="text-danger fs-8 mt-1">{errors.mdate}</div>}
                </div>

                <div className="col-lg-8 mb-3">
                    <label className="text-black font-w500 fs-7">Description</label>
                    <textarea rows={8} className="form-control" name="comment" placeholder="Description"
                        maxLength={255}
                        value={description}
                        onChange={(e) => setdescription(e.target.value)}
                    />
                </div>

            </div>

            <div className="form-check custom-checkbox mb-3">
                <input
                    type="checkbox"
                    checked={isChecked}
                    onChange={handleCheckboxChange}
                    className="form-check-input me-3"
                    id="customCheckBox1"
                    required
                />
                <label className='text-red fs-4 font-w600 mb-3'>Insurance Information</label>
            </div>
            {isChecked && (
                <div className='row'>
                    <div className="col-lg-4 mb-4 ">
                        <label className="text-black font-w500 fs-7">Insurance Company<span className="required">*</span></label>
                        <input type="text" className="form-control" placeholder="Enter Insurance Company"
                            maxLength={300}
                            value={insurance_company}
                            onChange={(e) => setinsurancecompany(e.target.value)}
                        />
                        {errors.comp && <div className="text-danger fs-8 mt-1">{errors.comp}</div>}
                    </div>
                    <div className="col-lg-4 mb-4 ">
                        <label className="text-black font-w500 fs-7">Insurance Policy Number<span className="required">*</span></label>
                        <input type="text" className="form-control" placeholder="Enter Insuance Policy Number"
                            maxLength={100}
                            value={insurance_prolicy}
                            onChange={(e) => setinsurance_policy(e.target.value)}
                        />
                        {errors.policy && <div className="text-danger fs-8 mt-1">{errors.policy}</div>}
                    </div>
                    <div className="col-lg-4 mb-4 ">
                        <label className="text-black font-w500 fs-7">Insurance Start Date<span className="required">*</span></label>
                        <div className='datepicker-wrapper d-flex'>
                            <div className='input-group-text bg-transparent border-0 px-0'><i className='fa-solid fa-calendar-days fs-4'></i></div>
                            <DatePicker placeholder='Select Insurance Start Date'
                                value={insurance_start_dateDisp}
                                onChange={(date) => {
                                    setinsurance_start_dateDisp(date);
                                    const formatted = date.format('YYYY-MM-DD');
                                    setinsurance_start_date(formatted);
                                }}
                                format="DD-MM-YYYY"
                            />
                        </div>
                        {errors.sdate && <div className="text-danger fs-8 mt-1">{errors.sdate}</div>}
                    </div>
                    <div className="col-lg-4 mb-4 ">
                        <label className="text-black font-w500 fs-7">Insurance End Date<span className="required">*</span></label>
                        <div className='datepicker-wrapper d-flex'>
                            <div className='input-group-text bg-transparent border-0 px-0'><i className='fa-solid fa-calendar-days fs-4'></i></div>
                            <DatePicker placeholder='Select Insurance End Date'
                                value={insurance_end_dateDisp}
                                onChange={(date) => {
                                    setinsurance_end_dateDisp(date);
                                    const formatted = date.format('YYYY-MM-DD');
                                    setinsurance_end_date(formatted);
                                }}
                                format="DD-MM-YYYY"
                                minDate={insurance_start_dateDisp}
                            />
                        </div>
                        {errors.edate && <div className="text-danger fs-8 mt-1">{errors.edate}</div>}
                    </div>
                </div>
            )}

            <div className='row'>
                <div className="col-lg-4 mb-4">
                    <label className="text-black font-w500 fs-7 d-block">Machinery  Image</label>
                    <span className='fs-8 text-gray-800'>Size: </span>
                    <span className='fs-8 text-danger'>15 * 15</span>
                    <span className='fs-8 text-gray-800 ms-2'>Format: </span>
                    <span className='fs-8 text-danger'>.png, .jpg</span>
                    <div className="avatar-upload d-flex align-items-center">
                        <div className="change position-relative">

                            <div className="avatar-preview h-125px w-125px border" style={{ borderRadius: '10px' }}>
                                {imageurl && (
                                    <>
                                        <img
                                            id="saveImageFile"
                                            src={(imgBaseUrl && imageurl) ? imgBaseUrl + '/' + imageurl : vehicle}
                                            alt={image ? image.name : 'Default Avatar'}
                                            className="p-1 h-125px w-125px"
                                        />
                                    </>
                                )}
                                {!imageurl && (
                                    <img
                                        id="saveImageFile"
                                        src={image ? URL.createObjectURL(image) : vehicle}
                                        alt={image ? image.name : 'Default Avatar'}
                                        className="p-1 h-125px w-125px"
                                    />
                                )}
                            </div>
                            <div className="change-btn">
                                <input
                                    type="file"
                                    id="imageUpload"
                                    accept=".png, .jpg, .jpeg"
                                    style={{ display: 'none' }}
                                    onChange={fileHandler}
                                    ref={imageInputRef}
                                />
                                <div className="mt-2 d-flex justify-content-center gap-3">
                                    <Button
                                        className="btn-xs mb-2"
                                        variant="success"
                                        onClick={() => imageInputRef.current.click()}
                                    >
                                        <span className="">
                                            <i className="fa fa-upload color-success fs-5" />
                                        </span>
                                    </Button>
                                    <Button
                                        className="btn-xs mb-2"
                                        variant="danger"
                                        onClick={RemoveImage}
                                    >
                                        <span className="">
                                            <i className="fa fa-close color-danger fs-5" />
                                        </span>
                                    </Button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="d-flex align-items-center justify-content-end gap-3 mt-4">
                <Link to={'/manage-machinery'} type="reset" className="btn btn-sm btn-secondary">Cancel</Link>
                <Button type="submit" className="btn btn-sm btn-primary" onClick={handleSubmit}>Update Machinery</Button>
            </div>
        </>
    )


}
export default EditVehicle;